<template>
  <!-- 发送验证码到邮箱 -->
  <div class="forget-password">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
      label-position="top"
    >
      <!-- 输入邮箱 -->
      <el-form-item :label="$t('pages.login.text13')" prop="mailAddress">
        <el-input v-model="ruleForm.mailAddress"></el-input>
      </el-form-item>
      <!-- 提交 -->
      <el-form-item>
        <el-button class="btn" type="primary" @click="submit()">{{
          $t("pages.login.text22")
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { validatEmailAddress } from "../../utils/util/test";
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        mailAddress: null, //邮箱地址
        platformId: "", //平台方id
      },
      //邮箱验证
      rules: {
        mailAddress: [{ validator: validatEmailAddress, trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  methods: {
    //提交邮箱后跳转到输入验证码页面
    submit() {
      this.ruleForm.platformId = this.platformData.id;
      this.$refs["ruleForm"].validate((valid) => {
        let that = this;
        if (valid) {
          let str = "?";
          for (let i in this.ruleForm) {
            str = str + i + "=" + this.ruleForm[i] + '&';
          }
          this.request
            .getVerificationCode(str)
            .then(() => {
              this.$router.push({
                path: "/verificationCode",
                query: {
                  mailAddress: that.ruleForm.mailAddress,
                },
              });
            })
            .catch((err) => {
              this.$message.error(err.msg);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.forget-password {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.demo-ruleForm {
  width: 340px;
  margin-top: 200px;
}
.btn {
  width: 100%;
  border-radius: 15px;
}
</style>